export enum Resolution886ResultEnum {
    INITIAL = 'INITIAL',
    GENERAL = 'GENERAL'
}